const SLiderTitleSkeleton = () => {
  return (
    <div className="flex gap-1 items-start h-11  py-3">
      {Array(10)
        .fill("")
        .map((_item, i) => (
          <div
            key={i}
            className="bg-gray-200 animate-pulse w-3 h-3 rounded-full"
          />
        ))}
    </div>
  );
};

export default SLiderTitleSkeleton;
